"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDomainConfig = exports.entry_config = void 0;
const react_1 = __importDefault(require("react"));
exports.entry_config = [
    // Define the domain for the themes.
    {
        domains: [""],
        config: {
            slogan: react_1.default.createElement(react_1.default.Fragment, null),
            colors: {
                slogan: {
                    text: "text-[#ffffff]",
                },
                buttons: {
                    bgPrimary: "bg-[#0000E0]",
                    textPrimary: "text-[#ffffff]",
                },
                checkbox: {
                    box: "text-[#0000E0]",
                },
                link: {
                    text: "text-[#0000E0]",
                },
                radio: {
                    box: "text-[#0000E0]",
                },
            },
            logo: {
                // light: LT_Logo_Light,
                light: "",
                dark: "",
            },
            sideImage: "",
        },
    },
    {
        domains: ["chenosis.io"],
        config: {
            slogan: (react_1.default.createElement(react_1.default.Fragment, null,
                "Your products,",
                react_1.default.createElement("br", null),
                "on-demand")),
            colors: {
                slogan: {
                    text: "text-[#ffffff]",
                },
                buttons: {
                    bgPrimary: "bg-[#141D26]",
                    textPrimary: "text-[#ffffff]",
                },
                checkbox: {
                    box: "text-[#141D26]",
                },
                link: {
                    text: "text-[#D8205F]",
                },
                radio: {
                    box: "text-[#141D26]",
                },
            },
            logo: {
                light: "",
                dark: "",
            },
            sideImage: "",
        },
    },
];
function findDomainConfig() {
    const domain = window.location.host;
    let conf = exports.entry_config.find((c) => c.domains.some((d) => domain.includes(d)));
    if (!conf) {
        conf = exports.entry_config[0]; // Default to Let's Trade.
    }
    return conf;
}
exports.findDomainConfig = findDomainConfig;
